import { req } from '../@api/request';
import { NplCalculation } from '../utils/nplAnalysis';

export interface INplInfo {
  address: string;
  ai: number;
  appraisedprice: string;
  bondPrice: number;
  buildingarea: string;
  caseno: string;
  claimAmount: string;
  court: string;
  creditee: string;
  div_date: string;
  itemcatetory: string;
  landarea: string;
  rightholder: string;
  sale_date: { date: string; price: string }[];
  start_date: string;
  stats: number;
  itemList: {
    unitno: string;
    iaddr: string;
    bid: string;
    appraisedprice: string;
    minprice: string;
  }[];
  approval_date: string;
  zoning: string;
  floor: string;
  seniorInfo: NplCalculation['seniorInfo'];
  is_company: 'Y' | 'N';
  marketPrc: number;
}

export default class DetailService {
  static detail = async (iidx: number) => {
    const result = await req.get(`/loan/detail?iidx=${iidx}`);
    return result.data;
  };
  static usestatus = async (iidx: number) => {
    const result = await req.get(`/loan/usestatus?iidx=${iidx}`);
    return result.data;
  };
  static nearbyItems = async (iidx: number) => {
    const result = await req.get(`/loan/detail/arround?iidx=${iidx}`);
    return result.data;
  };

  static getNplAnalysis = async (iidx: number): Promise<INplInfo> => {
    const result = await req.get(`/analysis/npl/info2?iidx=${iidx}`);
    return result.data.data;
  };

  static dividend = async (iidx: number, m_price: number) => {
    const result = await req.post(`/loan/dividend`, { iidx, m_price });
    return result.data;
  };

  static realDealPrice = async (
    iidx: number,
    b_idx: number,
    distance: number,
    limit: number,
    offset: number,
  ) => {
    let url = `/loan/realdeal?distance=${distance}&limit=${limit}&offset=${offset}`;
    url += b_idx ? `&b_idx=${b_idx}` : `&iidx=${iidx}`;
    const result = await req.get(url);
    return result.data;
  };

  static aroundRealDealPrice = async (
    iidx: number,
    b_idx: number,
    distance: number,
    limit: number,
    offset: number,
  ) => {
    let url = `/loan/arroundRealDeal?distance=${distance}&limit=${limit}&offset=${offset}`;
    url += b_idx ? `&b_idx=${b_idx}` : `&iidx=${iidx}`;
    const result = await req.get(url);
    return result.data;
  };

  /** 시세분석 api */
  static priceAnalysis = async (iidx: number) => {
    const result = await req.get(`/loan/detail/price?iidx=${iidx}`);
    return result.data;
  };
}
